import { IconButton } from "web/components"
import useDropDownMenu from "web/hooks/behaviour/useDropDownMenu"
import { pluralize } from "web/services/inflector"
import { paramsToQueryString } from "web/routes/constants"

//TODO: eliminate all this guessing, just pass export path into ObjectList
function getSubjectExportPrefix(listType, subjectType, viewId, viewType) {
  switch (listType) {
    case "view_comparison":
      return viewType === "group"
        ? `/api/view_groups/${viewId}`
        : `/api/views/${viewId}`
    default:
      return `/${pluralize(subjectType)}`
  }
}

function generateUrls({
  exportPath,
  parentSubjectType,
  parentSubjectId,
  subjectType,
  subjectId,
  topicId,
  view,
  listType,
}) {
  const { id: viewId, type: viewType } = view

  const params = {
    view_id: viewId,
    view_type: viewType,
    page: -1,
  }

  if (!exportPath) {
    params.subject_id = subjectId
    params.subject_type = subjectType
    params.parent_type = parentSubjectType
    params.parent_id = parentSubjectId

    if (topicId) {
      params.topic_id = topicId
      params.parent_type = subjectType
      params.parent_id = subjectId
    }
  }

  const queryString = paramsToQueryString(params)

  if (!!exportPath) {
    return {
      excelURL: `${exportPath}/export.xlsx?${queryString}`,
      pdfURL: `${exportPath}/export.pdf?${queryString}`,
    }
  } else if (topicId) {
    return {
      excelURL: `/topic_records/exports.xlsx?${queryString}`,
      pdfURL: `/topic_records/exports.pdf?${queryString}`,
    }
  } else {
    const prefix = getSubjectExportPrefix(
      listType,
      subjectType,
      viewId,
      viewType
    )

    return {
      excelURL: `${prefix}/exports.xlsx?${queryString}`,
      pdfURL: `${prefix}/exports.pdf?${queryString}`,
    }
  }
}

function ListItem({ text, href }) {
  return (
    <li className="flex items-center p-3 text-primary-4">
      <a href={href}>{text}</a>
    </li>
  )
}

export default function ExportButton({
  exportPath,
  parentSubjectType,
  parentSubjectId,
  subjectType,
  subjectId,
  topicId,
  view,
  listType,
  onlyExcel,
}) {
  const { DropDownMenu, menuVisible, toggleMenu } = useDropDownMenu({
    triggerElementId: "export-data",
  })

  const { pdfURL, excelURL } = generateUrls({
    exportPath,
    parentSubjectType,
    parentSubjectId,
    subjectType,
    subjectId,
    topicId,
    view,
    listType,
  })

  function downloadFile() {
    window.location.href = excelURL
  }

  return (
    <>
      {onlyExcel ? (
        <IconButton
          id="export-excel-data"
          outline
          name="document-arrow-down"
          onClick={downloadFile}
          className="hidden sm:flex"
        />
      ) : (
        <IconButton
          id="export-data"
          outline
          name="document-arrow-down"
          onClick={toggleMenu}
          active={menuVisible}
          className="hidden sm:flex"
        />
      )}

      {menuVisible && !onlyExcel && (
        <DropDownMenu>
          <div className="container max-w-xs">
            <ul className="m-0 list-none pl-0 text-sm">
              <ListItem href={excelURL} text="Export as Excel" />
              <ListItem href={pdfURL} text="Export as PDF" />
            </ul>
          </div>
        </DropDownMenu>
      )}
    </>
  )
}
